import * as funcAppApi from './func_app_api'
import { getApiV1Url, getApiV2Url } from '@/config/runtimeConfig'
import { applyValidVisitLmp } from '@/utils/visitLmp'

/**
 * True when the body is already `[{ records: [...] }]` from a prior normalize step.
 * Do NOT use `body[0].records` alone — SQL rows may have a column named `records`,
 * which caused skipping the wrap and broke setDocData (expects message.data[0].records[0].page_ele).
 */
function isSingleRecordsEnvelope (body) {
  if (!Array.isArray(body) || body.length !== 1) return false
  const o = body[0]
  if (!o || typeof o !== 'object' || !Array.isArray(o.records)) return false
  const keys = Object.keys(o)
  return keys.length === 1 && keys[0] === 'records'
}

/**
 * `func_app_api.getDocument` returns a flat JSON array from RESTFUL_DOCSEARCH.
 * Legacy `/doc/GetByParameters` consumers expect either:
 * - a bare array (doc type catalog: rid=0, rec=0, subclass=0, visit=0), or
 * - `[{ records: row[] }]` for lists / templates (Vuex docList, docData, page_ele).
 */
function normalizeDocumentResponseForLegacyConsumers (axiosRes, { rid, recId, subclassId, visitId }) {
  const body = axiosRes.data
  const catalogQuery =
    Number(rid) === 0 &&
    Number(recId) === 0 &&
    Number(subclassId) === 0 &&
    Number(visitId) === 0
  if (catalogQuery) {
    if (isSingleRecordsEnvelope(body)) {
      axiosRes.data = body[0].records
      return axiosRes
    }
    if (body != null && !Array.isArray(body) && Array.isArray(body.records)) {
      axiosRes.data = body.records
      return axiosRes
    }
    if (body != null && !Array.isArray(body) && !body.records) {
      axiosRes.data = [body]
    }
    return axiosRes
  }
  if (body != null && isSingleRecordsEnvelope(body)) {
    return axiosRes
  }
  if (body != null && !Array.isArray(body) && body.records) {
    axiosRes.data = [body]
    return axiosRes
  }
  const rows = Array.isArray(body) ? body : (body == null ? [] : [body])
  axiosRes.data = [{ records: rows }]
  return axiosRes
}

export function GetUserInformation ({ userId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/user/GetByParameters?user_id=' + userId + '&user_group_list&keyword=&group_id=1'
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/** Current-user profile (Bearer). Hosted on apiV2 (Azure Functions …/api/me). */
export function GetMe (cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV2Url() + 'me'
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — Vuex `GetPatientByCardId` / `SEARCH_PATIENT` never dispatched; search uses `func_app_api.searchPatient`
// export function GetPatientByCardId ({ cardId, groupId }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/patients/GetByParameters?group_id=' + groupId + '&patient_stage=X&limit_list=1&keyword=' + cardId + '&cardid=' + cardId
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

// export function GetPatientByKeyword ({ keyword, groupId }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/patients/GetByParameters?group_id=' + groupId + '&patient_stage=X&limit_list=10&keyword=' + keyword + '&cardid='
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function GetPatientById ({ id, groupId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/patients/GetByParameters?group_id=' + groupId + '&patient_stage=X&limit_list=1&keyword=' + id + '&cardid='
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — queue uses `visit/GET_QUEING_VISIT` → `func_app_api.getVisitRecords` instead
// export function GetQueingVisitByDate ({ datetime, groupId, userId }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/visits/GetByParameters?rid=0&user_id=' + userId + '&per_status_list=0|1|2|R&per_date=' + datetime + '&visit_id=0&group_id=' + groupId
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function GetWaitingVisitByDate ({ datetime, userId, status, groupId, token }, cb, errorCb) {
  // visits/GetByParameters?rid=0&user_id=30&per_status_list=5&per_date=2020-01-08&visit_id=0&group_id=9
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/visits/GetByParameters?rid=0&user_id=' + userId + '&per_status_list=' + status + '&per_date=' + datetime + '&visit_id=0&group_id=' + groupId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — Vuex `visit/GET_VISIT_BY_RID` is never dispatched
// export function GetQueingVisitByRid ({ rid, groupId, token, userId }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/visits/GetByParameters?rid=' + rid + '&user_id=' + userId + '&per_status_list=0|1&per_date=&visit_id=0&group_id=' + groupId
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function UpdateVisitById ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/visits/',
    data: applyValidVisitLmp(data)
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetShiftsInfoByDate ({ date, grouplist, groupid, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/shifts/GetByParameters?user_id=0&group_id=' + groupid + '&start_date=' + date + '&user_group_list=' + grouplist + '&ot_status='

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetDrugFromDx ({ keyword, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/nquiz/GetByParameters?id=' + keyword

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDx ({ dxList, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/nquiz',
    data: dxList
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetSuggestedDrugFromVisit ({ visitId, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/nresponse/GetByParameters?id=' + visitId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDrug ({ drugList, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/nresponse',
    data: drugList
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetLabelFromGroupStock ({ datetime, groupstock, status, token, userId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/label/GetByParameters?group_stock=' + groupstock + '&user_id=' + userId + '&visit_id=0&order_id_list&per_status=' + status + '&transfer_dt=' + datetime

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetLabelFromVisitId ({ visitId, token, groupstock, mode, userId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/label/GetByParameters?group_stock=' + groupstock + '&user_id=' + userId + '&visit_id=' + visitId + '&order_id_list&per_status=' + mode + '&transfer_dt='
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostLabel ({ labelList, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/label',
    data: labelList
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetDiagFromKeyword ({ keyword }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/diag/GetByParameters?visit_id=0&rid=0&cont=1&keyword=' + keyword
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetDiagFromVisit ({ visitId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/diag/GetByParameters?visit_id=' + visitId + '&rid=0&cont=1&keyword=%'
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDiag ({ diagList }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/diag',
    data: diagList
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostOrder ({ order }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/orders',
    data: order
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetOrderByVisit ({ visitId, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/orders/' + visitId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetReport ({ userId, reportVal, groupId, sd, ed, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/report/GetByParameters?user_id=' + userId + '&report_val=' + reportVal + '&group_id=' + groupId + '&sd=' + sd + '&ed=' + ed

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetStock ({ groupId, groupStock, matGroup, active, matDesc, rid, token }, cb, errorCb) {
  funcAppApi.getStock(
    { groupId, groupStock, matGroup, active },
    cb,
    errorCb
  )
}

export function PostStock ({ body }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/stock/',
    data: body
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetRestock ({ groupId, groupStock, matGroup, active, matDesc }, cb, errorCb) {
  funcAppApi.getRestock({ groupId }, cb, errorCb)
}

export function PostRestock ({ body }, cb, errorCb) {
  funcAppApi.postRestock({ body }, cb, errorCb)
}

export function GetPatient ({ groupId, patientStage, limitList, cardId, keyword }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/patients/GetByParameters?group_id=' + groupId + '&patient_stage=' + patientStage + '&limit_list=' + limitList + '&cardid=' + cardId + '&keyword=' + keyword

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostPatient ({ body }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/patients/',
    data: body
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetAllergy ({ keyword }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/allergy/' + keyword

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetBag ({ groupId, setId, checkStart, userId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/bag/GeyByParameters?group_id=' + groupId + '&set_id=' + setId + '&check_start=' + checkStart + '&user_id=' + userId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostAllergy ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/allergy/',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetApply ({ keyword }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/apply/' + keyword

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetSet ({ userId, groupId, usetId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/uset/GetByParameters?visit_id=0&uset_id=' + usetId + '&user_id=' + userId + '&rid=0&group_id=' + groupId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostSet ({ data, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/uset/',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

/** @deprecated Fast Track load uses `getFastTrack` in func_app_api (GET /api/fast-track). */
export function getFastTrack (param) {
  return funcAppApi.getFastTrack(param)
}

export function PostBag ({ body, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/bag/',
    data: body
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — Vuex `PostNreverse` calls `func_app_api.createFastTrack` directly
// export function PostNreverse ({ data, token }, cb, errorCb) {
//   const requestKey = crypto.randomUUID()
//   funcAppApi.createFastTrack(data, requestKey).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function GetDepartmentCode ({ groupId, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/box/GetById?group_id=' + groupId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetAvailableBed ({ groupid, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/bed?group_id=' + groupid + '&admitting=0'

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — inventory bag flow uses `func_app_api.postBox` instead
// export function PostBoxOrder ({ body, token }, cb, errorCb) {
//   window.axios({
//     method: 'post',
//     url: getApiV1Url() + '/box/',
//     data: body
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function GetAllBed ({ groupid, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/bed?group_id=' + groupid + '&admitting=1'

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetCreatedBed ({ groupid }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/bed?group_id=' + groupid + '&admitting=2'
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostBed ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/bed',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — callers use `GetDocByRid` / `getDocument` instead
// export function GetDocListByRid ({ rid, groupId }, cb, errorCb) {
//   funcAppApi.getDocument({
//     class_id: 0,
//     subclass_id: 0,
//     rid,
//     rec_id: 0,
//     group_id: groupId,
//     visit_id: 0
//   }).then(response => {
//     cb(normalizeDocumentResponseForLegacyConsumers(response, {
//       rid,
//       recId: 0,
//       subclassId: 0,
//       visitId: 0
//     }))
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function GetDocByRid ({ rid, rec, groupId }, cb, errorCb) {
  funcAppApi.getDocument({
    class_id: 0,
    subclass_id: 0,
    rid,
    rec_id: rec,
    group_id: groupId,
    visit_id: 0
  }).then(response => {
    cb(normalizeDocumentResponseForLegacyConsumers(response, {
      rid,
      recId: rec,
      subclassId: 0,
      visitId: 0
    }))
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — doc catalog uses `GetDocByRid({ rid: 0, rec: 0 })` instead
// export function GetAllDocType ({ groupId }, cb, errorCb) {
//   funcAppApi.getDocument({
//     class_id: 0,
//     subclass_id: 0,
//     rid: 0,
//     rec_id: 0,
//     group_id: groupId,
//     visit_id: 0
//   }).then(response => {
//     cb(normalizeDocumentResponseForLegacyConsumers(response, {
//       rid: 0,
//       recId: 0,
//       subclassId: 0,
//       visitId: 0
//     }))
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function GetDocTemplateWithData ({ rid, subclass, visit, groupId }, cb, errorCb) {
  funcAppApi.getDocument({
    class_id: 0,
    subclass_id: subclass,
    rid,
    rec_id: 0,
    group_id: groupId,
    visit_id: visit
  }).then(response => {
    cb(normalizeDocumentResponseForLegacyConsumers(response, {
      rid,
      recId: 0,
      subclassId: subclass,
      visitId: visit
    }))
  }).catch(error => {
    errorCb(error)
  })
}

export function PostDoc ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/doc/',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetGroupInfo ({ groupId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/group/GetByParameters?group_id=' + groupId + '&group_stock=0&group_stamp=0'
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetLabTest ({ rid, visitId, pon, testStatusList, groupId, per_date}, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/test/GetByParameters?rid=' + rid + '&visit_id= ' + visitId + '&pon=' + pon + '&test_status_list=' + testStatusList + '&group_id=' + groupId + (per_date ? '&per_date=' + per_date : '')

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetLabOrderByRid ({ rid, status, groupId, visitId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/test/?rid=' + rid + '&visit_id=' + visitId + '&pon=0&test_status_list=' + status + '&group_id=' + groupId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostLabTest ({ data, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/test/',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetLabItemById ({ id, visitId, groupId }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/lab/GetByParameters?id=' + id + '&sv_id=0&visit_id=' + visitId + '&group_id=' + groupId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostLabOrder ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/test/',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostApply ({ data, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/apply/',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetTeleVisitByDate ({ datetime, groupId, token, userId = 0 }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/visits/GetByParameters?rid=0&user_id=' + userId + '&per_status_list=2&per_date=' + datetime + '&visit_id=0&group_id=' + groupId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetConsult ({ userId, groupId, hid, filter, mine, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/consult/GetByParameters?hid=' + hid + '&user_id=' + userId + '&group_id=' + groupId + '&filter=' + filter + '&mine=' + mine

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostConsult ({ data, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/consult/',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — no GET `/drugs/{rid}` callers (`PostDrugs` is still used)
// export function GetDrugs ({ rid, token }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/drugs/' + rid
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function PostDrugs ({ data, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/drugs',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetTestBySVID ({ sv_id, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/lab/GetByParameters?visit_id=0&sv_id=' + sv_id + '&id='

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetLabRes ({ pon_list, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/labres/GetByParameters?pon_list=' + pon_list

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — no trace API callers in src/
// export function GetTrace ({ rid, groupId, token, traceStatus }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/trace/GetByParameters?rid=' + rid + '&group_id=' + groupId + '&trace_status=' + traceStatus
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

// export function PostTrace ({ data, token }, cb, errorCb) {
//   window.axios({
//     method: 'post',
//     url: getApiV1Url() + '/trace',
//     data: data
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function GetShifts ({ date, groupList, groupId, userId, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/shifts/GetByParameters?group_id=' + groupId + '&user_group_list=' + groupList + '&start_date=' + date + '&ot_status=X&user_id=' + userId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetShiftsByStatus ({ date, groupList, groupId, userId, status, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/shifts/GetByParameters?group_id=' + groupId + '&user_group_list=' + groupList + '&start_date=' + date + '&ot_status=' + status + '&user_id=' + userId
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetDuty ({ groupId, userGroup, month, year, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/duty/GetByParameters?group_id=' + groupId + '&user_group=' + userGroup + '&hu_status=A&mo=' + month + '&yr=' + year + '&dy=0'

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetUserList ({ userGroup, keyword, groupId }, cb, errorCb) {
  // console.log(getHeader(token))
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/user/GetByParameters?user_id=0&user_group_list=' + userGroup + '&keyword=' + keyword + '&group_id=' + groupId

  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostShift ({ data, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/shifts/',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — only `src/components/Archive/` (no router entry; broken `@/components/claim/*` imports)
// export function GetOperationList ({ visitId, token }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/claims/GetByParameters?visit_id=' + visitId + '&filter=1&id='
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function PostDuty ({ data, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/duty/',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetHoliday ({ groupList, spec, month, year, token }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/holy/GetByParameters?group_list=' + groupList + '&spec=' + spec + '&mo=' + month + '&yr=' + year
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostHoliday ({ data, token }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/holy/',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetFastTrack ({ userId, sympSearch, codeDiag, strucSearch, atc, groupId, drugSearch }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/fasttrack/GetByParameters?user_id=' + userId + '&symp_search=' + sympSearch + '&code_diag=' + codeDiag + '&struc_search=' + strucSearch + '&atc=' + atc + '&group_id=' + groupId + '&drug_search=' + drugSearch
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostInsurance ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/insurance',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — only `src/components/Archive/_claim/ClaimSearch.vue`
// export function GetClaimingList ({ perStatusList, groupId, token, userId }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/visits/GetByParameters?rid=0&user_id=' + userId + '&per_status_list=' + perStatusList + '&per_date=&visit_id=0&group_id=' + groupId
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function PostFastTrack ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/fasttrack',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostUser ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/user',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function GetUserByKeyword ({ keyword }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/user/GetByParameters?user_id=0&user_group_list=&keyword=' + keyword + '&group_id='
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — only `src/components/Archive/_claim/InsuranceVisitList.vue`
// export function GetVisits ({ userId, groupId, status }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/visits/GetByParameters?rid=0&user_id=' + userId + '&per_status_list=' + status + '&per_date=&visit_id=0&group_id=' + groupId
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

// export function GetClaims ({ visitId, filter, id }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/claims/GetByParameters?visit_id=' + visitId + '&filter=' + filter + '&id=' + id
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

// export function PostClaims ({ data }, cb, errorCb) {
//   window.axios({
//     method: 'post',
//     url: getApiV1Url() + '/claims',
//     data: data
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function GetVsign ({ rid, startdate, enddate, limit }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/vsign/GetByParameters?rid=' + rid + '&mobile=0&start_dt=' + startdate + '&end_dt=' + enddate + '&device_timestamp=0&limit_result=' + limit
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostVsign ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/vsign',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — imported in `CompanyProfile` / `GroupStockDialog` but never called (`save()` is empty)
// export function PostGroupInfo ({ data }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/group',
//     data: data
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function GetStamp ({ group_id, user_group, user_id, focus_date }, cb, errorCb) {
  window.axios({
    method: 'get',
    url: getApiV1Url() + '/stamp/?group_id=' + group_id + '&user_group=' + user_group + '&user_id=' + user_id + '&focus_date=' + focus_date
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function PostStamp ({ data }, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/stamp',
    data: data
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — only `src/components/Archive/dashboard/_DashboardLayout.vue`
// export function Bed (param) {
//   return window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/bed?group_id=' + param.groupId + '&admitting=' + param.admitting
//   })
// }

// Unused — superseded by `GetQueingVisitByDate` / `postVisit`
// export function getVisit ({ datetime, groupId, userId }, cb, errorCb) {
//   window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/visits/GetByParameters?rid=0&user_id=' + userId + '&per_status_list=0|1|2|R&per_date=' + datetime + '&visit_id=0&group_id=' + groupId
//   }).then(response => {
//     cb(response)
//   }).catch(error => {
//     errorCb(error)
//   })
// }

export function postVisit (data, cb, errorCb) {
  window.axios({
    method: 'post',
    url: getApiV1Url() + '/visits/',
    data: applyValidVisitLmp(data)
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

// Unused — duplicate of `GetDiagFromKeyword` path; no callers
// export function searchICD10 ({ keyword }) {
//   return window.axios({
//     method: 'get',
//     url: getApiV1Url() + '/diag/GetByParameters?visit_id=0&rid=0&cont=1&keyword=' + keyword
//   })
// }

export function GetDiagFromPatient (param) {
  return window.axios({
    method: 'get',
    url: getApiV1Url() + `/diag/GetByParameters?visit_id=0&rid=${param.rid}&cont=1&keyword=`
  })
}